import { parseSiteConfigObject } from '../api/utils/api/siteConfigApi';
import { CsInfo, SITE_CONFIG_KEY } from '../constants/types/site-config-type';
import { useSiteConfig } from './useSiteConfig';

/**
 * 고객센터 정보 폴백값 (설정 조회 실패 시 사용)
 * 어드민 값을 바꾸면 이 값도 함께 갱신해야 오래된 연락처가 노출되지 않는다.
 */
export const CS_INFO_FALLBACK: CsInfo = {
  phone: '1800-0588',
  email: 'cs@jebs.kr',
  hours: '평일 10:00~17:00 (점심시간 13:00~14:00)',
};

const SITE_CONFIG_KEYS = [SITE_CONFIG_KEY.CS_INFO];

/**
 * 고객센터 정보 설정 값 파싱
 * 조회 실패 또는 빠진 필드는 폴백값으로 채운다. 훅을 쓸 수 없는 곳에서도 사용한다.
 */
export const toCsInfo = (value?: string): CsInfo => ({
  ...CS_INFO_FALLBACK,
  ...parseSiteConfigObject<Partial<CsInfo>>(value),
});

/** 고객센터 정보(연락처, 이메일, 상담 시간) 조회 */
export const useCsInfo = () => {
  const { configs } = useSiteConfig(SITE_CONFIG_KEYS);
  return toCsInfo(configs[SITE_CONFIG_KEY.CS_INFO]);
};
